  import React, {useEffect, useState} from 'react';
  import { useLocation , useNavigate } from 'react-router-dom';
  import styles from './Servies.module.css'; // Ensure you're using the correct stylesheet
  import { useTranslation } from "react-i18next";
import TabsComponent from '../Categories/TabsComponent/TabsComponent';
import image1 from '../../Images/noimage.jpeg';

const Details = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [externalTab, setExternalTab] = useState();
      const { t, i18n } = useTranslation();
      const currentLanguage = i18n.language;
    const cardData = location?.state?.cardData ? location?.state?.cardData :  null; // Get card data from navigation state

    console.log("location",location?.state)
    useEffect(()=>{
      if(!location?.state || location?.state == null ) navigate('/services')
    },[])


    const data = 'هناك حقيقة مثبتة منذ زمن طويل وهي أن المحتوى المقروء لصفحة ما سيلهي القارئ عن التركيز على الشكل الخارجي للنص أو شكل توضع الفقرات في الصفحة التي يقرأها. ولذلك يتم استخدام طريقة لوريم إيبسوم لأنها تعطي توزيعاَ طبيعياَ -إلى حد ما- للأحرف عوضاً عن استخدام "هنا يوجد محتوى نصي، هنا يوجد محتوى نصي" فتجعلها تبدو (أي الأحرف) وكأنها نص مقروء. العديد من برامح النشر المكتبي وبرامح تحرير صفحات الويب تستخدم لوريم إيبسوم بشكل إفتراضي كنموذج عن النص، وإذا قمت بإدخال "lorem ipsum" في أي محرك بحث ستظهر العديد من المواقع الحديثة العهد في نتائج البحث. على مدى السنين ظهرت نسخ جديدة ومختلفة من نص لوريم إيبسوم، أحياناً عن طريق الصدفة، وأحياناً عن عمد كإدخال بعض العبارات الفكاهية إليها.'
    const handleSelection = () => {
      setExternalTab(2);
      navigate('/serviceproviders',  { state: { cardData: cardData } }); 
    };

    return (
      <div className='flex-grow-1'>
    <div style={{display:'none'}}>
    {externalTab && <TabsComponent externalTab={externalTab} setExternalTab={setExternalTab} />}
    </div>
    <div className={styles.DetailsLabel} >{cardData?.itm_nam}</div>
      <div className={styles.DetailsComponant}>
        <div className={styles.detailsContent}>
        <h1>{t('details')}</h1>
         <div style={{display:"flex", justifyContent:"space-between", alignItems:"start", width:"100%"}}>
         <div>
          {currentLanguage === "ar"
    ? cardData?.itm_descr1.trim() // Arabic branch name
    : cardData?.itm_descr2.trim() || cardData?.itm_descr1.trim() // English branch name (fallback to Arabic if empty)
  }
          </div>
          <div>
          <img
        src={(cardData?.itm_IMG && cardData?.itm_IMG?.trim() !="" ) ? `https://reservation.ladycaresa.com/public/uploads${cardData.itm_IMG}` : image1}
        alt={cardData.itm_nam}
        className={styles.cardImage}
        style={{borderRadius:"8px", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)"}}
      />
          </div>
         </div>
      { cardData?.itm_dessal > 0 && <>
       
          <div className={styles.priceContainer}>
            <span>{t('priceBeforeDiscount')}</span>
            {currentLanguage === "ar" ? (
  <span style={{ 
    textDecoration: "line-through",
    textDecorationColor: "darkred",
    textDecorationThickness: "3px", // Increase thickness
    textDecorationLine: "line-through",
    color: "darkred"
   }}>
    {cardData?.itm_prc2?.toFixed(2)} ريال
  </span>
) : (
  <span style={{ 
    textDecoration: "line-through",
    textDecorationColor: "darkred",
    textDecorationThickness: "3px", // Increase thickness
    textDecorationLine: "line-through",
    color: "darkred" }}>
    {cardData?.prcandtax?.toFixed(2)} S.R
  </span>
)}          </div>
          <div className={styles.priceContainer}>
            <span>{t('DiscountPercentage')}</span>
            {<span>{(cardData?.itm_dessal?.toFixed(2))*100} % </span>}
          </div>

          </>}
          <div className={styles.priceContainer}>
            <span>{t('Service Period')}</span>
            {currentLanguage === "ar" ? <span>{cardData?.itm_hassrl} دقيقة</span> : <span>{cardData?.itm_hassrl} minute </span>}
          </div>
          <div className={styles.priceContainer}>
            <span>{t('price')}</span>
            {currentLanguage === "ar" ? <span>{cardData?.prcandtax?.toFixed(2)} ريال</span> : <span>{cardData?.prcandtax?.toFixed(2)} S.R</span>}
          </div>
        </div>
      </div>
          <div className={styles.onSubmit} onClick={handleSelection} >{t('choose')}</div>
  </div>
    );
  };

  export default Details;
